import React from 'react';
import { Card } from 'react-bootstrap';
import Chart from 'react-apexcharts';
import { useFotaMetrics } from '../hooks/useMetrics';
import { getFotaBarChartConfig } from '../configs/chartConfigs';

const FotaChart = ({ selectedManufacturer = 'toyota' }) => {
  const { fotametricsdata, loading } = useFotaMetrics(selectedManufacturer);
  const fotaBarChart = getFotaBarChartConfig(fotametricsdata);
  return (
    <Card style={{ height: '480px' }}>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <span>FOTA Version of Vehicles</span>
        {/* <Badge bg="secondary">Last 24 hours</Badge> */}
      </Card.Header>
      <Card.Body>
        {fotametricsdata.length > 0 && !loading ? (
          <div style={{ height: '380px', overflowY: 'auto', overflowX: 'hidden' }}>
            <Chart
              options={fotaBarChart.options}
              series={fotaBarChart.series}
              type="bar"
              height={Math.max(400, fotametricsdata.length * 30)}
            />
          </div>
        ) : (
          <div className="d-flex align-items-center justify-content-center" style={{ height: '400px' }}>
            <span className="text-muted">{ loading ? 'Loading FOTA version data...' : 'No data available' }</span>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default FotaChart;
